import React from 'react';
import { Box } from '@chakra-ui/core';
import Pagination from '../../../../common/Pagination/Pagination';
import { useStoreState, useStoreActions } from '../../../../../models/hooks';

export const PositionPagination = React.memo(function PositionPagination() {
  const { isBulkAssignMode, positionResponse, isFetchingPosition, positionFilters } = useStoreState(
    (state) => state.moniterByRecruiters,
  );
  const { setPositionFilter } = useStoreActions((state) => state.moniterByRecruiters);

  const currentPage = positionFilters.page || 1;
  const itemsPerPage = positionFilters.limit || 20;

  const lastPage = React.useMemo(() => Math.max(1, Number(positionResponse?.lastPage ?? 1)), [positionResponse]);

  const handlePageChange = React.useCallback(
    (page: number) => {
      setPositionFilter({ key: 'page', value: page });
    },
    [setPositionFilter],
  );

  const handleItemsPerPageChange = React.useCallback(
    (numItems: number) => {
      setPositionFilter({ key: 'limit', value: numItems });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [setPositionFilter, isBulkAssignMode, positionFilters.limit],
  );

  return (
    <Box position="sticky" bottom={0} bg="white" zIndex={1} borderTop="1px solid #e5e5e5" borderBottomRadius="md">
      <Box px={2} py={1}>
        <Pagination
          currentPage={currentPage}
          lastPage={lastPage}
          total={positionResponse?.count ?? /* istanbul ignore next */ 0}
          onPageChange={handlePageChange}
          onItemsPerPageChange={handleItemsPerPageChange}
          itemsPerPage={itemsPerPage}
          isFetching={isFetchingPosition}
          storageKey="moniterRecruiter"
          options={isBulkAssignMode ? [20, 40, 50] : undefined}
        />
      </Box>
    </Box>
  );
});
